import React from "react";
import { NavBar } from "../components/NavBar";
import { Hero } from "../components/Hero";
import { Philosophy } from "../components/Philosophy";
import { UXCases } from "../components/UXCases";
import { Skills } from "../components/Skills";
import { LittleNote } from "../components/LittleNote";
import { Contact } from "../components/Contact";
import { Footer } from "../components/Footer";
import { Seo } from "../components/Seo";
import { useLanguage } from "../context/LanguageContext";

const Portfolio = () => {
    const { lang } = useLanguage();

    const description =
        lang === "nl"
            ? "Portfolio van Charlyn De Wulf, UX Designer en Strategist in België. Enterprise UX, design systems en research-gedreven productdesign."
            : "Portfolio of Charlyn De Wulf, UX Designer and Strategist based in Belgium. Enterprise UX, design systems and research-led product design.";

    return (
        <main data-testid="portfolio-page">
            <Seo
                description={description}
                path="/"
                type="profile"
                lang={lang}
            />
            <NavBar />
            <Hero />
            <Philosophy />
            <UXCases />
            <LittleNote />
            <Skills />
            <Contact />
            <Footer />
        </main>
    );
};

export default Portfolio;
